import type { Step } from '@de/types/types';
import type { MonarchIdentity } from './monarchIdentity';

export type CustomDimension = { key: string; value: string };

interface BuildCustomDimensionsParams {
  elementLoadedCorrelationId: string;
  currentStep?: Step;
  // Overrides `sourceCorrelationId`; results steps anchor on
  // `formViewedCorrelationId` instead of the default `elementLoadedCorrelationId`.
  sourceCorrelationId?: string;
  providedCustomDimensions?: CustomDimension[];
  monarch?: MonarchIdentity;
  // Derived members: `slotId` (from `placementId`) and `experienceVariant`.
  slotId?: string;
  experienceVariant?: string;
}

// Builds the deduped entry-point `customDimensions`. Caller-provided dimensions
// override by key (later writes win).
export const buildCustomDimensions = ({
  elementLoadedCorrelationId,
  currentStep,
  sourceCorrelationId,
  providedCustomDimensions = [],
  monarch,
  slotId,
  experienceVariant,
}: BuildCustomDimensionsParams): CustomDimension[] => {
  const flowId = currentStep?.flowId ?? '';
  const base: CustomDimension[] = [
    {
      key: 'sourceCorrelationId',
      value: sourceCorrelationId ?? elementLoadedCorrelationId,
    },
    { key: 'experienceVariant', value: experienceVariant ?? '' },
    { key: 'formId', value: flowId ? `dexp-${flowId}` : '' },
    { key: 'stepId', value: currentStep?.id ?? '' },
    { key: 'stepTitle', value: currentStep?.title ?? '' },
    { key: 'experienceName', value: monarch?.experienceName ?? '' },
    { key: 'slotName', value: monarch?.slotName ?? '' },
    { key: 'slotId', value: slotId ?? '' },
    { key: 'slotVariant', value: monarch?.slotVariant ?? '' },
    { key: 'flowId', value: flowId },
  ];

  const merged = new Map<string, CustomDimension>();
  for (const dim of [...base, ...providedCustomDimensions]) {
    merged.set(dim.key, dim);
  }
  return Array.from(merged.values());
};
